/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A queued re-judge of an event.
 * @export
 * @interface EventRejudgeRead
 */
export interface EventRejudgeRead {
    /**
     * 
     * @type {number}
     * @memberof EventRejudgeRead
     */
    submissions: number;
}

/**
 * Check if a given object implements the EventRejudgeRead interface.
 */
export function instanceOfEventRejudgeRead(value: object): value is EventRejudgeRead {
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    return true;
}

export function EventRejudgeReadFromJSON(json: any): EventRejudgeRead {
    return EventRejudgeReadFromJSONTyped(json, false);
}

export function EventRejudgeReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventRejudgeRead {
    if (json == null) {
        return json;
    }
    return {
        
        'submissions': json['submissions'],
    };
}

export function EventRejudgeReadToJSON(json: any): EventRejudgeRead {
    return EventRejudgeReadToJSONTyped(json, false);
}

export function EventRejudgeReadToJSONTyped(value?: EventRejudgeRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissions': value['submissions'],
    };
}

